import React from 'react';

import Button from 'components/shared/Buttons/Button/Button';

const WeekArrows = ({ changeWeekHandle }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        icon="chevron-left-linear"
        iconColor="neutral"
        variant="tertiary"
        size="xs"
        onClick={() => changeWeekHandle('prev')}
        className="p-0.5"
        iconShade={700}
      />
      <Button
        icon="chevron-right-linear"
        iconColor="neutral"
        variant="tertiary"
        size="xs"
        onClick={() => changeWeekHandle('next')}
        className="p-0.5"
        iconShade={700}
      />
    </div>
  );
};

export default WeekArrows;
